import { gql } from '@apollo/client'

import { ProfileQuickviewContent } from '../../profile-quickview/profile-quickview-content'
import { ProfileQuickviewQuery } from './__generated__/doc-popover-profile.graphql'

export type DocPopoverProfileProps = {
  query: ProfileQuickviewQuery
}

export function DocPopoverProfile(props: DocPopoverProfileProps) {
  const {
    query: {
      root: { profile },
    },
  } = props

  // caught by the error boundary
  if (!profile) throw new Error('Profile not found')

  return <ProfileQuickviewContent profile={profile} />
}

DocPopoverProfile.query = gql`
  query ProfileQuickview($pid: Int!) {
    root {
      profile(pid: $pid) {
        __typename
        id
        fullname
        url
        followingAmount
        followersAmount
        isLawyer
        profileType
        isVerified
        isInstitutional
        entityId
        entityType
        isFollowedByViewer
        hasProBadge
        cover: thumborCoverImage {
          url: thumbUrl(size: "320x112")
        }
        avatar: thumborAvatar {
          url2xl: thumbUrl(size: "96x96")
        }
        occupation {
          title
        }
        homeLocation {
          title
        }
      }
    }
  }
`
